<template>
  <div class="container">
    <HeadingOne class="-margin-md"
      >お探しのページが見つかりませんでした</HeadingOne
    >

    <section>
      <p>
        お探しのページが移動または削除されたか、URLの入力間違いの可能性があります。<br />
        au PAY スマートローントップより目的のページをお探しください。<br />
        ３秒後にau PAY スマートローントップへ自動的に遷移します。
      </p>
    </section>

    <BtngroupSingle class="-margin-lg">
      <BtnMain class="-main -md" router-name="sv001">
        au PAY スマートローントップへ
      </BtnMain>
    </BtngroupSingle>
  </div>
</template>

<script>
import HeadingOne from "../components/heading/HeadingOne";
import BtngroupSingle from "../components/button/BtngroupSingle";
import BtnMain from "../components/button/BtnMain";
import { setMeta } from "@/utils/Meta";

export default {
  name: "Tem028",
  components: {
    BtnMain,
    BtngroupSingle,
    HeadingOne,
  },
  setup() {
    setMeta({
      title: "お探しのページが見つかりませんでした",
      description: "",
      keywords: "",
    });
  },
  data() {
    return {};
  },
  mounted() {
    setTimeout(this.goToServiceTop, 3000);
  },
  methods: {
    goToServiceTop() {
      this.$router.push({ name: "sv001" });
    },
  },
};
</script>

<style scoped></style>
